var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table responsive", attrs: { id: "usersettingsview" } },
    [
      _vm.countries.length > 1
        ? _c("div", { staticClass: "tr" }, [
            _c("div", { staticClass: "td td3" }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.$t("country")) + "\n\t\t"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "td td3x2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.countryid,
                      expression: "countryid",
                    },
                  ],
                  staticClass: "selectBox",
                  attrs: { name: "countryid" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.countryid = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.onChange,
                    ],
                  },
                },
                _vm._l(_vm.countries, function (country) {
                  return _c(
                    "option",
                    { key: country.id, domProps: { value: country.id } },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(country.name) + "\n\t\t\t\t"
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.languages.length
        ? _c("div", { staticClass: "tr" }, [
            _c("div", { staticClass: "td td3" }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.$t("language")) + "\n\t\t"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "td td3x2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userLanguage,
                      expression: "userLanguage",
                    },
                  ],
                  staticClass: "selectBox",
                  attrs: { name: "language" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.userLanguage = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.onChange,
                    ],
                  },
                },
                _vm._l(_vm.languages, function (language) {
                  return _c(
                    "option",
                    { key: language.id, domProps: { value: language.id } },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(language.name) + "\n\t\t\t\t"
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currencies.length
        ? _c("div", { staticClass: "tr" }, [
            _c("div", { staticClass: "td td3" }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.$t("currency")) + "\n\t\t"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "td td3x2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userCurrency,
                      expression: "userCurrency",
                    },
                  ],
                  staticClass: "selectBox",
                  attrs: { name: "currency" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.userCurrency = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.onChange,
                    ],
                  },
                },
                _vm._l(_vm.currencies, function (currency) {
                  return _c(
                    "option",
                    { key: currency.id, domProps: { value: currency.id } },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(currency.name) +
                          " (" +
                          _vm._s(currency.sign) +
                          ")\n\t\t\t\t"
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }